import { animate } from '../../helpers/animate.js';
window.animate = animate;

const SLIDE_DURATION = 500;
const SLIDE_EASING = 'cubic-bezier(0.25, 0, 0, 1)';
const FADE_DURATION = 250;

export default class BlogMeta {

    constructor($element) {
        this.$element = $element;
        this.$toggle = $element.querySelector('[data-blog-meta-toggle]');
        this.$bios = $element.querySelector('[data-blog-meta-bios]');

        this.isVisible = false;

        this.$bios.style.opacity = 0;
        this.$bios.style.height = 0;
        this.$bios.style.overflow = 'hidden';

        this.$toggle.setAttribute('aria-expanded', 'false');
        this.$toggle.setAttribute('aria-controls', this.$bios.id);

        this.$toggle.addEventListener('click', event => {
            event.preventDefault();

            return this.isVisible ? this.slideUp() : this.slideDown();
        });
    }

    slideDown() {
        this.isVisible = true;
        this.$toggle.setAttribute('aria-expanded', 'true');

        animate(this.$bios, { height: 'auto' }, {
            duration: SLIDE_DURATION,
            easing: SLIDE_EASING,
        });

        animate(this.$bios, { opacity: 1 }, {
            duration: FADE_DURATION,
            delay: SLIDE_DURATION - FADE_DURATION,
        });
    }

    slideUp() {
        this.isVisible = false;
        this.$toggle.setAttribute('aria-expanded', 'false');

        animate(this.$bios, { height: 0 }, {
            duration: SLIDE_DURATION,
            easing: SLIDE_EASING,
        });

        animate(this.$bios, { opacity: 0 }, {
            duration: FADE_DURATION,
        });
    }

}
